var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('img',{staticStyle:{"width":"100%"},style:({height:_vm.height}),attrs:{"alt":"","src":_vm.imgSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }